import sseAPI from '@/api/sse.api.js';
import { isValidJSON } from '../../utils/json';
import { DOCUMENT_HEADER } from '../constant/QA_HEADER';
/**
 * sseMixin
 */
export default {
    data () {
        return {
            sseController: null
        };
    },
    methods: {
        /**
         * 发送sse流式问答
         */
        sendSseStream (prompt, apiType = 'default') {
            let typingTimeoutObj = null;
            let index = this.currentChat.messages.length - 1;
            let last = this.currentChat.messages[index]; // 最后一条消息（回答，用于打字）
            let lastAsk = this.currentChat.messages[index - 1]; // 倒数第二条消息（提问）
            last.thinking = true;
            sseAPI.sseStream(apiType, this.currentSessionId, prompt, (answer, sseController) => {
                last.thinking = false;
                this.sseController = sseController;
                if (lastAsk && !lastAsk.questionTime && answer.time) lastAsk.questionTime = parseInt(answer.time) || Date.now(); // 设置提问时间

                // 设置3秒超时，强制打字完成
                clearTimeout(typingTimeoutObj);
                typingTimeoutObj = setTimeout(async () => {
                    if (!this.ui.typing) return;

                    // 打字完成
                    this.ui.typing = false;
                    clearTimeout(typingTimeoutObj);
                    if (last && last.role === 'assistant') {
                        this.$set(last, 'finished', true);
                    }

                    if (this.mdTempStr.indexOf('```gpt-') === 0) {
                        // ```gpt-开头，加上```结尾
                        last.notShowContent = last.content = this.mdTempStr + '\n```';
                        this.mdTempStr = '';
                    }
                    this.saveContext();
                }, 3000);

                let str = answer.content;
                // str = str.replace(/�/g, '');
                if (str === '[done]')str = '';
                if (answer.status === 'FINISH') {
                    if (!this.ui.typing) return; // 已经打字完成，不再处理(一般是先timeout了)
                    // 打字完成
                    this.ui.typing = false;
                    clearTimeout(typingTimeoutObj);
                    if (last && last.role === 'assistant') {
                        this.$set(last, 'finished', true);
                    }

                    if (this.mdTempStr.indexOf('```gpt-') === 0) {
                        // ```gpt-开头，加上```结尾
                        last.notShowContent = last.content = this.mdTempStr + '\n```';
                        this.mdTempStr = '';
                    } else {
                        last.content += str;
                        if (!last.content) {
                            // 没有内容，显示默认回答
                            last.content = '服务器没有返回。';
                        }
                    }
                    this.saveContext();
                } else {
                    let str = answer.content;
                    // str = str.replace(/�/g, '');

                    // 打字
                    if (this.mdTempStr.indexOf('```gpt-') === 0) {
                        // 如果是```gpt-开头，则使用mdTempStr存储返回信息
                        this.mdTempStr += str;
                        last.notShowContent = this.mdTempStr;
                        last.content = '计算中，请稍候';
                        for (let i = 0; i < this.mdTempStr.length % 6; i++) {
                            last.content += ' .';
                        }
                    } else if (this.model === 'knowledge' && isValidJSON(str)) {
                        // 如果是知识库问答，需要特殊显示原文出处 还需先判断是否是Object类型字符串
                        let obj = JSON.parse(str);
                        // 如果有source字段代表展示原文出处
                        if (obj && obj.hasOwnProperty('source')) {
                            if (last.content) {
                                last.knowledgeSoucre = {
                                    knowledgeType: this.currentKnowledge.knowledgeType,
                                    source: obj.source,
                                    header: obj.header || DOCUMENT_HEADER // 原文出处表头
                                };
                            }
                        } else {
                            last.content += str;
                        }
                    } else {
                        last.content += str;
                    }
                }
            });
        }
    }
};
